import styled from "styled-components";
import propTypes from "prop-types";
import { ChevronDown } from "react-feather";

import { palette } from "./index";
import { mediaMin } from "./styles";

const Button = ({
  className,
  textColor = palette.white,
  backgroundColor = palette.secondary,
  hoverColor = palette.dark,
  hoverTextColor,
  borderColor,
  arrowColor,
  isMobileIcon,
  children,
  isActive,
  mobileIconOnly,
  ...allProps
}) => {
  return (
    <Butn
      className={`${className} ${isActive && "active"}`}
      textColor={textColor}
      backgroundColor={backgroundColor}
      hoverColor={hoverColor}
      hoverTextColor={hoverTextColor}
      borderColor={borderColor}
      {...allProps}
    >
      {children}
      {arrowColor && (
        <ChevronDown color={arrowColor} style={{ marginLeft: 5 }} />
      )}
    </Butn>
  );
};

Button.propTypes = {
  className: propTypes.string,
  textColor: propTypes.string,
  backgroundColor: propTypes.string,
  hoverColor: propTypes.string,
  leftIcon: propTypes.element,
  hasArrow: propTypes.bool,
  isMobileIcon: propTypes.bool,
  isActive: propTypes.bool,
};

const Butn = styled.button`
  display: flex;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  border: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : "none"};
  border-radius: 15px;
  height: 30px;
  padding: 0 15px;
  text-transform: uppercase;
  transition: all 300ms ease-in-out;
  font-size: 10px;
  line-height: 1;

  &:hover,
  &:active,
  &.active {
    background-color: ${({ hoverColor }) => hoverColor};
  }

  &:hover,
  &.active {
    color: ${({ hoverTextColor }) =>
      hoverTextColor ? hoverTextColor : palette.white};
    cursor: pointer;
    border-color: ${({ hoverColor }) =>
      hoverColor ? hoverColor : palette.white};

    svg {
      stroke: ${({ hoverTextColor }) =>
        hoverTextColor ? hoverTextColor : palette.white};
    }
  }

  ${mediaMin.tablet_sm`
    font-size: 13px;
    min-width: 150px;
  `};
`;

export { Button };
